





if ($('.ticker-slider-js').length) {

    new Splide('.ticker-slider-js', {
        type: "loop",
        perPage: 4,
        arrows: false,
        pagination: false,
        focus: false,
        gap: "80px",
        autoWidth: true,
        breakpoints: {
            701: {
                gap: "60px",
            },
        }
    }).mount(window.splide.Extensions);

}
if ($('.ingredient-badges-slider').length) {

    new Splide('.ingredient-badges-slider', {
        type: "loop",
        perPage: 4,
        arrows: false,
        pagination: false,
        focus: false,
        gap: "50px",
        autoWidth: true,
    }).mount(window.splide.Extensions);

}

if ($('.reviews-section').length && $('.reviews-section').is(':visible'))         // use this if you are using id to check
{
    var splide = new Splide('.reviews-section .review-slider-js', {
        perPage: 1,
        rewind: false,
        pagination: false,
        arrows: false,
        type: 'loop',
        autoplay: true,
    });

    splide.mount();
}

if ($('.reviews-section-two').length && $('.reviews-section-two').is(':visible'))         // use this if you are using id to check
{
    var reviewslidersplide = new Splide('.reviews-section-two .review-slider-two-js', {
        perPage: 1,
        rewind: false,
        pagination: false,
        arrows: false
    });

    reviewslidersplide.mount();
}

if ($('.best-seller-wrap').length) {
    var splideProduct = new Splide('.best-seller-wrap .splide', {
        perPage: 3,
        perMove: 1,
        gap: 20,
        rewind: false,
        pagination: false,
        arrows: true,
        breakpoints: {
            1400: {
                perPage: 3,
            },
            801: {
                perPage: 2,
            },
            701: {
                perPage: 1,
                gap: 10
            },
        }
    });

    splideProduct.mount();
}


if ($('.backed_science').length) {
    var splideProduct = new Splide('.backed_science .splide', {
        perPage: 2,
        gap: 20,
        rewind: false,
        pagination: false,
        arrows: true,
        breakpoints: {
            1400: {
                perPage: 2
            },
            801: {
                perPage: 2,
                gap: 10,
            },
            701: {
                perPage: 1,
                pagination: true,
                arrows: true
            }
        }
    });

    splideProduct.mount();
}

if ($('.difference-wrap').length) {
    var splideProduct = new Splide('.difference-wrap .difference-slider-js', {
        perPage: 2,
        gap: 10,
        rewind: false,
        pagination: false,
        arrows: false,
        breakpoints: {
            1400: {
                perPage: 2
            },
            801: {
                perPage: 2
            },
            701: {
                perPage: 1,
                pagination: true
            },
        }
    });

    splideProduct.mount();
}

// Scroll to review section

(function () {
    var REVIEW_TARGET_ID = 'judgeme_product_reviews';
    var SESSION_FLAG_KEY = 'judgeMeScrollToReviews';

    function getJudgeMeWidget() {
        return document.getElementById(REVIEW_TARGET_ID) || document.querySelector('.jdgm-reviews-widget');
    }

    function getHeaderOffset() {
        var selectors = [
            '.shopify-section-header',
            '.header-wrapper',
            'header.site-header',
            'header.header',
            '.header-section',
            'header'
        ];

        for (var i = 0; i < selectors.length; i++) {
            var el = document.querySelector(selectors[i]);
            if (!el) {
                continue;
            }

            var style = window.getComputedStyle(el);
            var isSticky = /fixed|sticky/i.test(style.position);

            if (isSticky || el.hasAttribute('data-sticky')) {
                return el.offsetHeight || 0;
            }
        }

        return 0;
    }

    function scrollToJudgeMeWidget(options) {
        var widget = getJudgeMeWidget();
        if (!widget) {
            return false;
        }

        var behavior = (options && options.behavior) || 'smooth';
        var headerOffset = getHeaderOffset();
        var top = widget.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

        window.scrollTo({
            top: top < 0 ? 0 : top,
            behavior: behavior
        });

        if (typeof widget.focus === 'function') {
            var previousTabIndex = widget.getAttribute('tabindex');

            widget.setAttribute('tabindex', '-1');
            widget.focus({ preventScroll: true });

            if (previousTabIndex === null) {
                var removeTabIndex = function () {
                    widget.removeEventListener('blur', removeTabIndex);
                    widget.removeAttribute('tabindex');
                };

                widget.addEventListener('blur', removeTabIndex);
            }
        }

        return true;
    }

    function waitAndScrollToJudgeMeWidget(options) {
        var attempts = 0;
        var maxAttempts = (options && options.maxAttempts) || 40;
        var delay = (options && options.delay) || 250;

        (function attemptScroll() {
            attempts += 1;
            if (scrollToJudgeMeWidget(options)) {
                return;
            }

            if (attempts < maxAttempts) {
                window.setTimeout(attemptScroll, delay);
            }
        })();
    }

    function shouldOpenInNewTab(event) {
        if (!event || event.type !== 'click') {
            return false;
        }

        return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1;
    }

    function navigateToJudgeMeReviews(badge, event) {
        if (!badge) {
            return;
        }

        var destination = badge.getAttribute('data-product-url');
        if (!destination) {
            return;
        }

        var url = new URL(destination, window.location.origin);
        var isSameProduct = url.pathname.replace(/\/+$/, '') === window.location.pathname.replace(/\/+$/, '');

        if (event) {
            if (shouldOpenInNewTab(event)) {
                window.open(url.toString(), '_blank', 'noopener');
                return;
            }

            event.preventDefault();
            event.stopPropagation();
        }

        if (isSameProduct) {
            waitAndScrollToJudgeMeWidget({ behavior: 'smooth' });
            return;
        }

        try {
            window.sessionStorage.setItem(SESSION_FLAG_KEY, 'true');
        } catch (error) {
            // sessionStorage may be unavailable, fallback to hash handling only
        }

        window.location.href = url.toString();
    }

    function handlePreviewBadgeClick(event) {
        var badge = event.target.closest('.jdgm-widget.jdgm-preview-badge[data-product-url]');
        if (!badge) {
            return;
        }

        navigateToJudgeMeReviews(badge, event);
    }

    function handlePreviewBadgeKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        var badge = event.target.closest('.jdgm-widget.jdgm-preview-badge[data-product-url]');
        if (!badge) {
            return;
        }

        event.preventDefault();
        navigateToJudgeMeReviews(badge, event);
    }

    function consumeScrollFlag() {
        try {
            var flag = window.sessionStorage.getItem(SESSION_FLAG_KEY);
            if (flag === 'true') {
                window.sessionStorage.removeItem(SESSION_FLAG_KEY);
                return true;
            }
        } catch (error) {
            // sessionStorage may be unavailable
        }

        return false;
    }

    function initJudgeMeScrollHandling() {
        document.addEventListener('click', handlePreviewBadgeClick, true);
        document.addEventListener('keydown', handlePreviewBadgeKeydown, true);

        var hashMatches = window.location.hash === '#' + REVIEW_TARGET_ID;
        var pendingScroll = consumeScrollFlag();

        if (hashMatches || pendingScroll) {
            waitAndScrollToJudgeMeWidget({ behavior: 'smooth' });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initJudgeMeScrollHandling);
    } else {
        initJudgeMeScrollHandling();
    }
})();


if ($('.real-people-slider-js').length) {
    var splideProduct = new Splide('.real-people-slider-js', {
        perPage: 4,
        gap: 20,
        arrows: true,
        autoplay: false,
        breakpoints: {
            1400: {
                perPage: 2,
            },
            801: {
                perPage: 2,
            },
            701: {
                perPage: 1,
            },
        }
    });

    splideProduct.mount();
}


// (Reviews scroll logic moved to reviews-scroll-clean.js)

// Hide "Read Reviews" if Klaviyo widget has no reviews
function checkKlaviyoReviews() {
    // Wait for Klaviyo widget to potentially load
    setTimeout(function () {
        var klaviyoWidget = $('.klaviyo-star-rating-widget');
        var readReviewElement = $('p.product__text.read_review');

        if (!readReviewElement.length) {
            return;
        }

        if (!klaviyoWidget.length) {
            readReviewElement.hide();
            return;
        }

        // Clone the widget so we can safely ignore the injected "Read Reviews" link
        var widgetClone = klaviyoWidget.clone();
        widgetClone.find('.klaviyo-read-reviews-text, p.product__text.read_review, style, script').remove();

        var widgetContent = widgetClone.find('div');
        var hasStars = widgetClone.find('.star, .rating, [class*="star"], [class*="rating"]').length > 0;
        var hasRatingButtons = widgetClone.find('button.kl_reviews__star_rating_widget, .kl_reviews__star_rating_widget').length > 0;
        var hasText = widgetClone.text().trim().length > 0;
        var hasRatingData = widgetClone.attr('data-rating') && widgetClone.attr('data-rating') !== '0';
        var widgetContainer = klaviyoWidget.closest('.shopify-app-block');

        var hasMeaningfulContent = hasStars || hasRatingButtons || hasText || hasRatingData;
        if (!hasMeaningfulContent) {
            if (!widgetContent.length || widgetContent.text().trim().length === 0) {
                readReviewElement.hide();
                klaviyoWidget.hide();
                if (widgetContainer.length) {
                    widgetContainer.hide();
                }
                return;
            }
        }

        klaviyoWidget.show();
        if (widgetContainer.length) {
            widgetContainer.show();
        }
        readReviewElement.show();
    }, 1000); // Check after 1 second to allow Klaviyo to load

    // Also check after a longer delay in case Klaviyo loads slowly
    setTimeout(function () {
        checkKlaviyoReviews();
    }, 3000);
}

// Run the check when document is ready
$(document).ready(function () {
    checkKlaviyoReviews();
});

// Also run check when page is fully loaded (in case Klaviyo loads later)
$(window).on('load', function () {
    setTimeout(checkKlaviyoReviews, 500);
});

// Backed Science Popup

$(document).ready(function () {
    $(".ingredient-link").click(function () {
        // $(".ingredient-popup").fadeIn("slow");
        $('.full_ingredient').slideToggle();

        if ($(this).find('.plus-icon').find('.plus').is(":visible")) {
            $(this).find('.plus-icon').find('.plus').hide();
        } else {
            $(this).find('.plus-icon').find('.plus').show();
        }

    });

    // $(".ingredient-popup-close").click(function(){
    //     $(".ingredient-popup").fadeOut("slow");
    // });
    $(".second-lavel-ul>li>a").click(function () {
        $(this).toggleClass('open');
        $(this).next('.third-lavel-ul').slideToggle();
    });


});


$('#owl-carousel').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000, // very short delay
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        }
    }
});




$('#owl-carousel-2').owlCarousel({
    loop: true,
    margin: 80,
    nav: true,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        }
    }
});

$('#owl-carousel-3').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    responsive: {
        0: {
            items: 1,
            dots: true
        },
        600: {
            items: 1,
            dots: true
        },
        1050: {
            items: 3,
            dots: false
        }

    }
});

$('#owl-carousel-4').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        },
        1050: {
            items: 4
        }
    }
});


// Footer collapsible menu



$(document).ready(function () {
    $(".footer-block__heading").click(function () {
        var $content = $(this).next(".footer-block__details-content");
        var $heading = $(this);

        $content.slideToggle("slow", function () {

            if ($content.is(":visible")) {
                $heading.addClass("is-open");
            } else {
                $heading.removeClass("is-open");
            }
        });
    });
});




$(".accordian_set > a").on("click", function () {
    var aAttr = $(this).attr('rel');
    //console.log(aAttr);
    $(".interactive-image .image-pointer").removeClass('active');
    $(".interactive-image .image-pointer." + aAttr).addClass('active');
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
            .siblings(".accordian_content")
            .slideUp(200);
    } else {
        $(".accordian_set > a").removeClass("active");
        $(this).addClass("active");
        $(".accordian_content").slideUp(200);
        $(this)
            .siblings(".accordian_content")
            .slideDown(200);
    }
});




// 27-5-25 Anamay



const items = document.querySelectorAll(".real-people-item");

items.forEach(function (item) {
    const video = item.querySelector("video");
    const playIcon = item.querySelector(".real-peole-play-icon");


    if (playIcon && video) {
        playIcon.addEventListener("click", function () {


            document.querySelectorAll(".real-people-item video").forEach(v => {
                if (v !== video) {
                    v.pause();
                    const otherIcon = v.closest(".real-people-item").querySelector(".real-peole-play-icon");
                    if (otherIcon) {
                        otherIcon.style.opacity = "1";
                        otherIcon.style.pointerEvents = "auto";
                    }
                }
            });

            video.play();
            playIcon.style.opacity = "0";
            playIcon.style.pointerEvents = "none";
        });



        video.addEventListener("click", function () {
            video.pause();
            playIcon.style.opacity = "1";
            playIcon.style.pointerEvents = "auto";
        });



        video.addEventListener("ended", function () {
            playIcon.style.opacity = "1";
            playIcon.style.pointerEvents = "auto";
        });
    }
});







// Improved Quantity-based price updater with better event handling
; (function () {
    const root = document;

    // Initialize clean state - clear any cart operation flags from previous pages
    window.cartOperationInProgress = false;

    // Reset all quantity inputs to 1 on page load to prevent cart contamination
    document.addEventListener('DOMContentLoaded', function () {
        const quantityInputs = document.querySelectorAll("input[name=\"quantity\"], .quantity__input");
        quantityInputs.forEach(input => {
            // Only reset if it's not in a cart context (avoid interfering with cart items)
            if (!input.closest('cart-items') && !input.closest('cart-drawer-items') && !input.closest('.cart-item')) {
                if (input.value != 1) {
                    input.value = 1;
                }
            }
        });
    }); function updateClosestVariantPrice(el, eventType) {
        // If cart is mutating, we normally skip; but allow explicit user interactions on product page
        const isFromCart = !!(el && el.closest && el.closest('cart-items, cart-drawer-items, .cart-item'));
        const productContext = el && el.closest && el.closest('[id^="ProductInfo-"], form[id^="product-form-"]');
        if (window.cartOperationInProgress && (!productContext || isFromCart)) {
            return;
        }

        // Ignore events originating from cart contexts entirely
        if (el && el.closest && el.closest('cart-items, cart-drawer-items, .cart-item')) {
            return;
        }

        const variantEl = el && el.closest ? el.closest('variant-selects, variant-radios') : null;
        if (variantEl && typeof variantEl.updateButtonPrice === 'function') {
            try {
                const prev = window.cartOperationInProgress;
                // Temporarily clear to allow a safe, scoped update from user action
                window.cartOperationInProgress = false;
                variantEl.updateButtonPrice(true);
                window.cartOperationInProgress = prev;
            } catch (e) { console.log('updateButtonPrice error:', e); }
        } else {
            // Fallback: find the nearest product info container and update just that one
            let container = el && el.closest ? el.closest('[id^="ProductInfo-"], .product__info-container, form[id^="product-form-"]') : null;
            if (container) {
                const vs = container.querySelector('variant-selects, variant-radios');
                if (vs && typeof vs.updateButtonPrice === 'function') {
                    try {
                        const prev = window.cartOperationInProgress;
                        window.cartOperationInProgress = false;
                        vs.updateButtonPrice(true);
                        window.cartOperationInProgress = prev;
                    } catch (e) { console.log('updateButtonPrice error:', e); }
                }
            }
        }
    }

    // Enhanced event listeners with more debugging

    // Listen for input events (typing in quantity field)
    root.addEventListener('input', function (e) {
        const t = e.target;
        if (t && (t.matches('input[name="quantity"]') || t.matches('.quantity__input'))) {

            updateClosestVariantPrice(t, 'input');
        }
    });

    // Listen for change events (including from QuantityInput component)
    root.addEventListener('change', function (e) {
        const t = e.target;
        if (t && (t.matches('input[name="quantity"]') || t.matches('.quantity__input'))) {

            updateClosestVariantPrice(t, 'change');
        } else if (t && t.tagName && t.tagName.toLowerCase() === 'quantity-input') {

            updateClosestVariantPrice(t, 'quantity-input change');
        }
    });

    // Listen for clicks on plus/minus buttons with improved timing
    root.addEventListener('click', function (e) {
        const btn = e.target && e.target.closest && e.target.closest('quantity-input button[name="plus"], quantity-input button[name="minus"]');
        if (btn) {
            // Ignore plus/minus clicks inside cart contexts
            if (btn.closest('cart-items, cart-drawer-items, .cart-item')) return;

            // Use both a short timeout and a longer one to catch the value change
            setTimeout(() => {

                updateClosestVariantPrice(btn, 'plus/minus click (10ms)');
            }, 10);

            setTimeout(() => {

                updateClosestVariantPrice(btn, 'plus/minus click (50ms)');
            }, 50);
        }
    });

    // Also listen for any custom events that might be dispatched
    root.addEventListener('quantity:changed', function (e) {

        updateClosestVariantPrice(e.target, 'custom quantity:changed');
    });

    console.log('Quantity price updater initialized');
})();
